angular.module('env.data.models.idModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes, FieldValidationTemplates) {
        restProvider.defineModel("IdModel",
            {
                fields: {
                    id: {
                        type: RepresentationModelFieldTypes.INTEGER,
                        validate: FieldValidationTemplates.notEmpty()
                    }
                }
            }
        );
    })

;